/**
 * Counter
 */
import './Counter.css';

import React from 'react';
import STATUS from '../Constants';

const Counter = (props) => {
  if (props.status !== STATUS.GAME_PLAY) {
    return null;
  }

  return (
    <div className="Counter">
      {props.matches} / {props.totalCards} matches
    </div>
  )
}

export default Counter;



// WEBPACK FOOTER //
// ./src/components/du/Game/Counter/Counter.js